export const TIERS = [
  {
    id: "starter", name: "Starter", target: "Pour les indépendants qui démarrent",
    price: "199 999", frequency: "/mois", cta: "Commencer", href: "/inscription?offre=starter",
    featured: false,
    quotas: ["1 utilisateur inclus", "10 factures / mois", "Ticket de caisse illimité", "Vue « Voir plus » : non"],
  },
  {
    id: "pro", name: "Pro", target: "Pour les boutiques avec un vendeur ou un gérant",
    price: "349 999", frequency: "/mois", cta: "Commencer", href: "/inscription?offre=pro",
    featured: false,
    quotas: ["2 utilisateurs inclus", "50 factures / mois", "Ticket de caisse illimité", "Vue « Voir plus » : non"],
  },
  {
    id: "business", name: "Business", target: "Pour les PME structurées avec une équipe",
    price: "999 999", frequency: "/mois", cta: "Commencer", href: "/inscription?offre=business",
    featured: true,
    quotas: ["Jusqu'à 5 utilisateurs", "Factures illimitées", "Ticket de caisse illimité", "Vue « Voir plus » : oui"],
  },
  {
    id: "custom", name: "Sur mesure", target: "Pour les grandes structures multi-établissements",
    price: null, frequency: null, cta: "Nous contacter", href: "/contact",
    featured: false,
    included: ["Utilisateurs illimités", "Multi-établissements et vue consolidée du groupe",
               "Accompagnement dédié", "Formation sur site", "Support prioritaire", "Export de données avancé"],
  },
];

export const FEATURE_MATRIX = [
  { name: "Dashboard temps réel (5 indicateurs)", tiers: ["starter", "pro", "business", "custom"] },
  { name: "Ventes au comptant et à crédit", tiers: ["starter", "pro", "business", "custom"] },
  { name: "Stock et alertes avant rupture", tiers: ["starter", "pro", "business", "custom"] },
  { name: "Clients, fournisseurs, créances et dettes", tiers: ["starter", "pro", "business", "custom"] },
  { name: "Traçabilité complète de chaque action", tiers: ["starter", "pro", "business", "custom"] },
  { name: "Mode sans stock (montant global)", tiers: ["starter", "pro", "business", "custom"] },
  { name: "Alertes anti-fraude (vente sous prix)", tiers: ["pro", "business", "custom"] },
  { name: "Assistant IA conversationnel", tiers: ["pro", "business", "custom"] },
  { name: "Rôles prédéfinis (gérant, vendeur)", tiers: ["pro", "business", "custom"] },
  { name: "Gestion RH (salaires, primes, heures sup.)", tiers: ["business", "custom"] },
  { name: "Permissions module par module", tiers: ["business", "custom"] },
  { name: "IA proactive (alertes sans question)", tiers: ["business", "custom"] },
  { name: "Multi-établissements", tiers: ["custom"] },
  { name: "Conversion carton / unité", tiers: ["custom"] },
];

export const TIER_TO_KEY = { starter: "tier1", pro: "tier2", business: "tier3", custom: "tier4" };
export const KEY_TO_TIER = { tier1: "Starter", tier2: "Pro", tier3: "Business", tier4: "Sur mesure" };

// Taux indicatif GNF -> EUR utilisé uniquement pour l'affichage secondaire (jamais pour facturer).
export const GNF_PER_EUR = 9700;

export function eurHint(amountGNF) {
  const eur = Math.round((amountGNF || 0) / GNF_PER_EUR);
  return `≈ ${eur} €/mois (indicatif)`;
}
